import createIcon from '../../createIcon';

/**
 * @component @name ResetTv
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTBIMTIuOTlWN0w5IDExTDEyLjk5IDE1VjEySDIxVjE3SDNWNUgyMVY4SDIzVjVDMjMgMy45IDIyLjEgMyAyMSAzSDNDMS45IDMgMSAzLjkgMSA1VjE3QzEgMTguMSAxLjkgMTkgMyAxOUg4VjIxSDE2VjE5SDIxQzIyLjEgMTkgMjIuOTkgMTguMSAyMi45OSAxN1YxMkgyM0MyMyAxMC45IDIyLjEgMTAgMjEgMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ResetTv = createIcon('ResetTv', [
  [
    'path',
    {
      d: 'M21 10H12.99V7L9 11L12.99 15V12H21V17H3V5H21V8H23V5C23 3.9 22.1 3 21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17V12H23C23 10.9 22.1 10 21 10Z',
      key: 'hu0lys',
    },
  ],
]);

export default ResetTv;
